// Route path → lazy chunk loader. Hovering / focusing a link warms the chunk so opening the page is instant.
const loaders = new Map();
const done = new Set();
export const registerPreload = (path, load) => loaders.set(path, load);

export function preloadPath(path) {
  const p = (path || "").split(/[?#]/)[0].replace(/\/+$/, "") || "/";
  const load = loaders.get(p);
  if (!load || done.has(p)) return;
  done.add(p);
  load().catch(() => done.delete(p));
}

let installed = false;
export function installLinkPrefetch() {
  if (installed || typeof document === "undefined") return;
  installed = true;
  const on = (e) => {
    const a = e.target?.closest?.("a[href]");
    if (!a || a.origin !== window.location.origin) return;
    preloadPath(a.pathname);
  };
  document.addEventListener("pointerover", on, { passive: true });
  document.addEventListener("focusin", on);
  document.addEventListener("touchstart", on, { passive: true });
}
